import React from 'react'
export const BreadcrumbContext = React.createContext({
  lastSectionName: null,
  setLastSectionName: (name: string | null) => {},
})
